var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewPageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 223,
    height: 158,
    viewBox: "0 0 223 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#2CABE0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-399 -490) translate(325 413) translate(74 77)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 155,
    x: 1.5,
    y: 1.5,
    fill: "#FFF",
    strokeWidth: 3,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M1.5 45.5L221 46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 26,
    r: 8.5,
    fill: "#FFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 26,
    r: 8.5,
    fill: "#FFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 26,
    r: 8.5,
    fill: "#FFF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3,
    transform: "translate(85.5 72)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 24.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M26 13.5L26 39.5"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M26 13.5L26 39.5",
    transform: "rotate(90 26 26.5)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPageIcon);
export default __webpack_public_path__ + "static/media/new-page-icon.e9138ea20bac607c31c77465bd6370e3.svg";
export { ForwardRef as ReactComponent };